import { ReactNode } from 'react';
// guards
import SubscriberLayout from '@subflow-frontend/layouts/subscriber';
import { SubscriberGuard } from '@subflow-frontend/guards/SubscriberGuard';
import { useSessionAuth } from '@subflow-frontend/hooks/useSessionAuth';
import LoadingScreen from '@subflow-frontend/components/LoadingScreen';
import NonAuthenticatedSubscriberLayout from '@subflow-frontend/layouts/NonAuthenticatedSubscriberLayout';
import { SUBSCRIBER_USER_TYPE } from '@subflow/data-access';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
  merchantLogo?: string;
  protectedPage?: boolean;
  name?: string;
  disableHorizontalPadding?: boolean;
  hideHeader?: boolean;
  hideOrgSwitcher?: boolean;
};

export default function SubscriberLayoutWrapper({
  children,
  merchantLogo,
  name,
  disableHorizontalPadding,
  protectedPage,
  hideHeader,
  hideOrgSwitcher,
  ...rest
}: Props) {
  const { isAuthenticated, loading, session } = useSessionAuth();
  if (loading) {
    return <LoadingScreen />;
  } else {
    if (
      (isAuthenticated && session.userType.includes(SUBSCRIBER_USER_TYPE)) ||
      protectedPage
    ) {
      return (
        <SubscriberGuard>
          <SubscriberLayout
            disableHorizontalPadding={disableHorizontalPadding}
            hideOrgSwitcher={hideOrgSwitcher}
            {...rest}
          >
            {children}
          </SubscriberLayout>
        </SubscriberGuard>
      );
    } else {
      return (
        <NonAuthenticatedSubscriberLayout
          showLogo={!!merchantLogo}
          logo={merchantLogo}
          name={name}
          hideHeader={hideHeader}
        >
          {children}
        </NonAuthenticatedSubscriberLayout>
      );
    }
  }
}
